import React from 'react';
import { Card } from '@clockout-dev/design-elements';
import AccessRulesCardHeader from './elements/AccessRulesCardHeader';
import AccessRulesReadOnlyNotice from './elements/AccessRulesReadOnlyNotice';
import AccessRulesStatusBanner from './elements/AccessRulesStatusBanner';
import AccessRuleCard from './elements/AccessRuleCard';
import { ACCESS_RULE_DEFS } from './accessRulesCard.constants';
import styles from './styles/accessRulesCard.module.scss';

function AccessRulesCard({ state, handlers = {}, readOnly = false }) {
    const { access_rules = {}, access_enabled = {} } = state || {};
    const paused = ACCESS_RULE_DEFS.some((def) => access_enabled[def.key]);

    return (
        <Card className={styles.summaryCard}>
            <AccessRulesCardHeader readOnly={readOnly} />
            {readOnly ? <AccessRulesReadOnlyNotice /> : null}
            <AccessRulesStatusBanner paused={paused} readOnly={readOnly} />
            <div className={styles.ruleList}>
                <AccessRuleCard
                    title="Negative Balance"
                    prefix="Negative >"
                    suffix="days"
                    days={access_rules?.negativeBalanceDays ?? 0}
                    enabled={access_enabled?.negativeBalance ?? false}
                    readOnly={readOnly}
                    onToggle={() => handlers.toggleAccessRule?.('negativeBalance')}
                    onChangeDays={(value) => handlers.updateAccessRuleDays?.('negativeBalanceDays', value)}
                />
                <AccessRuleCard
                    title="Overdraft & NSF Instances"
                    prefix="Negative >"
                    suffix="days"
                    days={access_rules?.overdraftNsfDays ?? 0}
                    enabled={access_enabled?.overdraftNsf ?? false}
                    readOnly={readOnly}
                    onToggle={() => handlers.toggleAccessRule?.('overdraftNsf')}
                    onChangeDays={(value) => handlers.updateAccessRuleDays?.('overdraftNsfDays', value)}
                />
                <AccessRuleCard
                    title="Loans Overdue"
                    prefix="No loan over"
                    suffix="days late"
                    days={access_rules?.loansOverdueDays ?? 0}
                    enabled={access_enabled?.loansOverdue ?? false}
                    readOnly={readOnly}
                    onToggle={() => handlers.toggleAccessRule?.('loansOverdue')}
                    onChangeDays={(value) => handlers.updateAccessRuleDays?.('loansOverdueDays', value)}
                />
            </div>
        </Card>
    );
}

export default AccessRulesCard;
